import { render, staticRenderFns } from "./dashboard4.vue?vue&type=template&id=16930462&scoped=true&"
import script from "./dashboard4.vue?vue&type=script&lang=js&"
export * from "./dashboard4.vue?vue&type=script&lang=js&"
import style0 from "./dashboard4.vue?vue&type=style&index=0&id=16930462&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16930462",
  null
  
)

export default component.exports